var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktokCommentsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50.000000pt",
    height: "50.000000pt",
    viewBox: "0 0 50.000000 50.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,50.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167 446 c-84 -31 -147 -111 -147 -186 0 -43 34 -114 68 -140 25 -20 25 -21 9 -56 -9 -19 -17 -37 -17 -41 0 -10 63 7 89 24 16 10 48 16 86 17 44 1 74 8 110 27 144 74 150 253 10 335 -56 32 -150 42 -208 20z m158 -17 c54 -15 121 -83 130 -132 12 -62 -3 -107 -49 -153 -46 -47 -99 -66 -174 -63 -33 1 -58 -5 -84 -21 -42 -24 -44 -23 -27 14 11 23 8 30 -29 70 -68 73 -69 158 -4 228 58 61 145 82 237 57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134 269 c-10 -17 13 -36 27 -22 12 12 4 33 -11 33 -5 0 -12 -5 -16 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234 269 c-10 -17 13 -36 27 -22 12 12 4 33 -11 33 -5 0 -12 -5 -16 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334 269 c-10 -17 13 -36 27 -22 12 12 4 33 -11 33 -5 0 -12 -5 -16 -11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokCommentsIcon);
export default __webpack_public_path__ + "static/media/tiktok-comments-icon.513682c7422aacdbe4abd7e95444064e.svg";
export { ForwardRef as ReactComponent };